export const GetMarketForm = "/Market/GetMarketForm";
export const GetMarketLoggedInForm = "/MarketLoggedIn/GetMarketLoggedInForm";

export const MarketFavorite = "/MarketLoggedIn/MarketFavorite";

export const GetMarketLoggedInList = ({ coinDestinationId }) =>
  `/MarketLoggedIn/GetMarketLoggedInList?CoinSourceId=-1&CoinDestinationId=${coinDestinationId}`;

export const GetSingleMarketLoggedInList = ({
  coinSourceId,
  coinDestinationId,
}) =>
  `/MarketLoggedIn/GetMarketLoggedInList?CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}`;

export const GetMarketListImportantWithGOLD =
  "/Market/GetMarketListImportantWithGOLD";
